import axiosInstance from '../axios/axios-instance';
import { UserExperienceFeedbackStatusDto } from 'shared/interfaces/user-experience-feedback/user-experience-feedback-status.dto';

export const userExperienceFeedbackApi = {
  async getStatus(): Promise<UserExperienceFeedbackStatusDto> {
    const response = await axiosInstance.get<UserExperienceFeedbackStatusDto>('/user-experience-feedback/status');
    return response.data;
  },

  async submit(answer: string): Promise<UserExperienceFeedbackStatusDto> {
    const response = await axiosInstance.post<UserExperienceFeedbackStatusDto>('/user-experience-feedback', {
      answer,
    });
    return response.data;
  },

  async acknowledgeResult(): Promise<void> {
    await axiosInstance.post('/user-experience-feedback/acknowledge-result');
  },
};
